<template>
	<div
		class="w-full max-w-140 group-[.received]:me-auto group-[.received]:pe-15 group-[.sent]:ms-auto group-[.sent]:ps-15"
	>
		<div
			class="rounded-xl p-3 w-full border group-[.received]:rounded-tl-none group-[.received]:bg-white group-[.received]:border-gray-darker group-[.received]:text-primary-superdark group-[.sent]:rounded-br-none group-[.sent]:bg-primary group-[.sent]:border-primary group-[.sent]:text-white"
		>
			<div
				v-if="chatStore.currentChannelMember?.id !== props.message.authorId"
				class="text-sm text-primary font-medium pb-2"
				:title="sendersName"
			>
				{{ sendersName }}
			</div>
			<div class="wrap-anywhere">
				<slot></slot>
			</div>
			<div
				class="text-end text-sm pt-2 group-[.received]:text-gray-darker group-[.sent]:text-gray-light"
			>
				<time
					:datetime="props.message.created"
					:title="
						formatDate(props.message.created, {
							showDate: true,
							showYear: true,
							showTime: true
						})
					"
				>
					{{
						formatDate(props.message.created, {
							showDate: false,
							showTime: true
						})
					}}
				</time>
			</div>
		</div>
	</div>
</template>

<script setup lang="ts">
import type { Props } from '@/types/Message'
import { computed } from 'vue'
import { formatDate } from '@/services/dateTimeService'
import { useChatStore } from '@/stores/chatStore'
const chatStore = useChatStore()

const props = defineProps<Props>()

const sendersName = computed<string>(() => {
	return (
		chatStore.currentChannel?.members?.find(
			(member) => member.id === props.message.authorId
		)?.name || ''
	)
})
</script>

<style scoped></style>
